<template>
  <div class="templates">
    <heading type="h1">Templates</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'templates',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .templates {

    }
</style>



// WEBPACK FOOTER //
// src/pages/templates.vue